export function slugToDisplayName(slug: string) {
  if (slug === 'current') {
    return 'Current season';
  }
  return slug.charAt(0).toUpperCase() + slug.substring(1).split('-').join(' ');
}
